import {
  defaultLocale,
  load as loadBase,
} from '@bottlebooks/gatsby-theme-event/src/wrapElement/lingui/i18n.config';
import { i18n } from '@lingui/core';
import de from '../../../../locales/de';
import en from '../../../../locales/en';

export { locales } from '@bottlebooks/gatsby-theme-event/src/wrapElement/lingui/i18n.config';
export { defaultLocale };

const catalogs = { de, en };

export function load(locale) {
  if (!locale) return {};
  const messages = { ...loadBase(locale), ...catalogs[locale]?.messages };
  i18n.load(locale, messages);
  return messages;
}
